<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Détails de mon compte<br/>Mares Libellules</p>
</div>
<div id="account-stats" class="pt-3 pb-2 px-3 bb">
	<div class="row">
		<div class="col">
			<p class="text-center mb-0">
				<span class="badge badge-dark number py-3"><?=user.toFixed('pond_nb',0)?></span>
				<span class="label text-dark fw-700 uc">Mares localisées</span>
			</p>
		</div>
		<div class="col">
			<p class="text-center mb-0">
				<span class="badge badge-dark number py-3"><?=user.toFixed('visit_nb',0)?></span>
				<span class="label text-dark fw-700 uc">Visites détaillées</span>
			</p>
		</div>
	</div>
</div>
<div id="account-details">
	<div class="list-group bb">
		<? _.each( item_list, function( label, key ) { ?>
			<div class="list-group-item">
				<small class="text-secondary"><?=label?></small><br/>
				<? if( user.has( key ) ) { ?>
					<?=user.get( key )?>
				<? } else { ?>
					<em class="text-muted">Non défini</em>
				<? } ?>
				<?-user.getFieldError(key)?>
			</div>
		<? }) ?>
	</div>
</div>
<div class="p-3 bb d-flex justify-content-between">
	<a href="#user/manage" class="btn btn-green"><i class="far fa-pencil"></i> Modifier</a>
	<a href="#user/password" class="btn btn-green"><i class="far fa-lock"></i> Mot de passe</a>
</div>

<div class="p-3">
	<p class="mb-0 text-center small text-secondary">
		<?-data.get('text_cnil')?>
	</p>
</div>

<? if( app.is('online') ) { ?>
	<div class="p-3 bt">
		<button type="button" data-toggle="modal" data-target="#account-delete-modal" class="btn btn-danger btn-block">
			<i class="far fa-trash-alt"></i> Demander la suppression de mon compte
		</button>
	</div>
<? } ?>

<div id="account-delete-modal" class="modal">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Attention !</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<p>Vous êtes sur le point de demander la suppression de votre compte utilisateur.<br/><br/>Cette action est irréversible et supprimera définitivement toutes vos données (mares, visites, photos).<br/><br/>Veuillez confirmer cette action.</p>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-dismiss="modal">Annuler</button>
				<button id="account_delete_modal_confirm" type="button" class="btn btn-danger">Confirmer la suppression</button>
			</div>
		</div>
	</div>
</div>

